import { render } from "./pay.vue?vue&type=template&id=43829748"
import script from "./pay.vue?vue&type=script&lang=js"
export * from "./pay.vue?vue&type=script&lang=js"

import "./pay.vue?vue&type=style&index=0&id=43829748&lang=scss"

import exportComponent from "D:\\Git\\思途茶业\\思途茶业pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__